import { replaceSpacesToNbsp } from "helpers/string";
import { AddressCreateData, type AddressData, AddressUpdateData } from "services/address/addressTypes";
import { type AddressFormValue } from "./addressTypes";

export const addressDataToForm = (address?: AddressData): AddressFormValue | undefined => {
  if (!address) {
    return;
  }

  return {
    premise: address.premise,
    street: address.street,
    town: address.town,
    id: address.id ?? undefined,
    postcode: address.postcode,
    county: address.county ?? undefined,
    country: address.country ?? undefined,
    externalAddressId: address.externalAddressId ?? undefined,
    isOwnedByCompany: address.isOwnedByCompany ?? undefined,
    occupierName: address.occupierName ?? undefined,
    occupierDeclaration: address.occupierDeclaration ?? undefined,
    isUsualResidentalAddress: address.isUsualResidentalAddress ?? undefined,
    asicApprovalNumber: address.asicApprovalNumber ?? undefined,
  };
};

export const isAustralianCountryAddress = (address?: AddressData): boolean => {
  return address?.country?.toLowerCase() === "australia";
};

export const addressFormToCreateData = (
  addressForm: AddressFormValue,
  ids: {
    companyId?: string;
    directorIdRegistered?: string;
    directorIdRegisteredPrevious?: string;
    companyActivityId?: string;
    businessCompanyId?: string;
  },
): AddressCreateData => {
  return new AddressCreateData({
    premise: addressForm.premise ?? "",
    street: addressForm.street ?? "",
    town: addressForm.town ?? "",
    postcode: addressForm.postcode ?? "",
    externalAddressId: addressForm.externalAddressId ?? undefined,
    county: addressForm.county ?? undefined,
    country: addressForm.country ?? undefined,
    isOwnedByCompany: addressForm.isOwnedByCompany ?? undefined,
    occupierName: addressForm.isOwnedByCompany ? "" : (addressForm.occupierName ?? undefined),
    occupierDeclaration: addressForm.isOwnedByCompany ? false : (addressForm.occupierDeclaration ?? undefined),
    isUsualResidentalAddress: addressForm.isUsualResidentalAddress ?? undefined,
    asicApprovalNumber: addressForm.isUsualResidentalAddress ? "" : (addressForm.asicApprovalNumber ?? undefined),
    companyId: ids.companyId,
    directorIdRegistered: ids.directorIdRegistered,
    directorIdRegisteredPrevious: ids.directorIdRegisteredPrevious,
    companyActivityId: ids.companyActivityId,
    businessCompanyId: ids.businessCompanyId,
  });
};

export const addressFormToUpdateData = (addressForm: AddressFormValue): AddressUpdateData => {
  return new AddressUpdateData({
    premise: addressForm.premise,
    street: addressForm.street,
    town: addressForm.town,
    postcode: addressForm.postcode,
    externalAddressId: addressForm.externalAddressId ?? undefined,
    county: addressForm.county ?? undefined,
    isOwnedByCompany: addressForm.isOwnedByCompany ?? undefined,
    occupierName: addressForm.isOwnedByCompany ? "" : (addressForm.occupierName ?? undefined),
    occupierDeclaration: addressForm.isOwnedByCompany ? false : (addressForm.occupierDeclaration ?? undefined),
    isUsualResidentalAddress: addressForm.isUsualResidentalAddress ?? undefined,
    asicApprovalNumber: addressForm.isUsualResidentalAddress ? "" : (addressForm.asicApprovalNumber ?? undefined),
    country: addressForm.country ?? undefined,
  });
};

export const formatAddress = (address?: AddressData): string => {
  if (!address) {
    return "";
  }

  // eslint-disable-next-line max-len
  return `${address.premise} ${address.street} ${address.town} ${replaceSpacesToNbsp(address.postcode)} ${address.country}`;
};
